import styled, { keyframes } from "styled-components";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  
  border-top: 2px solid grey;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
  border-left: 4px solid black;
  background: transparent;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const LoadingContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 40px;
`;

export const LoadingText = styled.p`
    margin-left: 10px;
    font-weight: 400;
`;

export const OverlayContainer = styled.div<{ open: boolean }>`
  position: fixed; 
  display: ${props => props.open ? 'block' : 'none'};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 101; 
`;

export const OverlayInner = styled.div`
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const OverlayContent = styled.div`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const OverlaySpinner = styled.div`
  width: 75px;
  height: 75px;
  display: inline-block;
  border-width: 4px;
  border-color: rgba(255, 255, 255, 0.05);
  border-top-color: #fff;
  animation: ${spin} 1s infinite linear;
  border-radius: 100%;
  border-style: solid;
`;

export const OverlayText = styled.p`
  left: -23%;
  position: absolute;
  top: 90%;
  color: #fff;
  font-weight: 500;
  font-size: 20px;
`;



